"use client"

import { usePathname } from "next/navigation"
import { useEffect } from "react"

function canonicalOrigin(): string {
  const raw = process.env.NEXT_PUBLIC_APP_URL?.trim().replace(/\/+$/, "")
  if (!raw) return window.location.origin
  try {
    return new URL(raw).origin
  } catch {
    return window.location.origin
  }
}

/**
 * Supabase recovery links sometimes land on Site URL (/) with tokens in the hash
 * instead of /redefinir-senha (e.g. www vs apex mismatch). Send those sessions to the
 * reset page so the existing hydration logic can run.
 *
 * Uses NEXT_PUBLIC_APP_URL as the canonical host so links align with env (e.g. apex without www).
 */
export function RecoveryHashRedirect() {
  const pathname = usePathname()

  useEffect(() => {
    if (pathname !== "/") return

    const url = new URL(window.location.href)
    const base = `${canonicalOrigin()}/redefinir-senha`

    const code = url.searchParams.get("code")
    if (code) {
      window.location.replace(`${base}${url.search}`)
      return
    }

    const rawHash = url.hash.replace(/^#/, "")
    if (!rawHash) return

    const params = new URLSearchParams(rawHash)
    if (params.get("type") !== "recovery") return

    const hasSession =
      Boolean(params.get("access_token")) && Boolean(params.get("refresh_token"))
    if (!hasSession) return

    window.location.replace(`${base}#${rawHash}`)
  }, [pathname])

  return null
}
